module.exports = __webpack_public_path__ + "img/fond_marc_correcteur.6e28155d.jpg";